import type { CNSWorkflowSnapshot } from "@/models/cns";

function nonBlankPublicId(value: string | null | undefined): string | null {
  const normalized = value?.trim();
  return normalized ? normalized : null;
}

/**
 * Resolves the Learning owned by the snapshot's current workflow lifecycle.
 *
 * Native synthesis state is authoritative whenever it exists. The broader
 * `latestLearningPublicId` projection may point at a prior cycle, so it is only
 * safe as a compatibility fallback once the snapshot is terminal.
 */
export function resolveWorkflowLearningPublicId(
  snapshot: CNSWorkflowSnapshot | null | undefined,
): string | null {
  if (!snapshot) {
    return null;
  }

  const synthesisLearningPublicId = nonBlankPublicId(
    snapshot.synthesisLearningPublicId,
  );
  if (synthesisLearningPublicId) {
    return synthesisLearningPublicId;
  }

  if (
    snapshot.currentStage !== "LEARNING" ||
    snapshot.activeActionRequests.length > 0 ||
    snapshot.permittedTransitionIds.length > 0
  ) {
    return null;
  }

  return nonBlankPublicId(snapshot.latestLearningPublicId);
}
